// src/pages/manager/sessions/AttendanceView.jsx
import React from "react";
import AttendanceView from "../../../components/attendance/AttendanceView";

const ManagerAttendanceView = () => {
    return <AttendanceView role="MANAGER" />;
};

export default ManagerAttendanceView;